"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layerRules = layerRules;
const types_1 = require("./types");
/**
 * Picks the winning rules from layers of increasing authority.
 *
 * Pass layers lowest-authority-first — `[federal, state]`. For each
 * `limitKey`, the last layer that has any rule for that key wins, and the
 * layers below it are ignored for that key. Keys a higher layer says nothing
 * about keep whatever the lower layer had, so a state that only sets a
 * central time limit keeps the federal satellite limits.
 *
 * A higher layer replaces the whole group of rules under a key, not one rule
 * at a time. If a state sets a central time limit, it replaces *every*
 * federal central time limit — including ones that only apply in specific
 * circumstances, like the longer deadline for shipping waste over 200 miles.
 * A state that doesn't grant that longer deadline shouldn't have it applied
 * to its facilities. See `LimitKey`.
 *
 * Nothing here enforces one winner per key — the winning layer contributes
 * every applicable rule it has under that key, and the clock treats each as
 * its own limit. Whether that comes to exactly one depends on how the layer
 * is written: the federal central time limits are separated by mutually
 * exclusive conditions (over 200 miles or not), so only ever one of them is
 * applicable at a time. A layer written without that discipline would resolve
 * to several limits of the same kind rather than being rejected here.
 */
function layerRules(layers) {
    const winningLayerByKey = new Map();
    for (const layer of layers) {
        for (const rule of layer.rules) {
            winningLayerByKey.set((0, types_1.limitKey)(rule), layer);
        }
    }
    // Walk the layers again rather than reading the map out, so the result
    // stays in a predictable order: lower layers first, then higher ones.
    const resolved = [];
    for (const layer of layers) {
        for (const rule of layer.rules) {
            if (winningLayerByKey.get((0, types_1.limitKey)(rule)) === layer) {
                resolved.push({ rule, source: layer.source });
            }
        }
    }
    return resolved;
}
//# sourceMappingURL=layerRules.js.map